module.exports = __webpack_public_path__ + "static/media/Renuka_Padalkar.5a11a820.jpg";